import React from "react"
import { Container, Row, Col } from "reactstrap"
import { FaCode } from "react-icons/fa"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import styled from "styled-components"

let StyledImg = styled((props) => <Img {...props} />)`
  perspective: 1500px;
  perspective-origin: left center;
  overflow: visible !important;
  picture,
  img {
    transform: rotateY(-35deg) rotateX(15deg);
    // box-shadow: 25px 60px 125px -25px rgba(80, 102, 144, 0.1),
    //   16px 40px 75px -40px rgba(0, 0, 0, 0.2);
    border-radius: 0.625rem;
    transition: 1s !important;
    &:hover {
      transform: rotateY(-30deg) rotateX(15deg);
    }
  }
`

let Benefit = ({ title, content }) => (
  <div className="d-flex mb-4">
    <div><FaCode size={20} style={{color: '#f77f00'}} /></div>
    <div className="ml-3">
      <p className="m-0" style="font-weight: bold;">{title}</p>
      <p className="m-0 text-muted">{content}</p>
    </div>
  </div>
)

let Benefits = ({ data }) => (
  <Container className="py-5">
    <Row className="d-flex align-items-center">
      <Col md="6">
        <Row className="d-flex align-items-center">
          <Col md="12">
            <div className="mb-4">
              <h2 style={{color: '#f77f00', fontWeight: '900'}}>What sets us apart?</h2>
              <p className="text-muted">In this age of constant tech development, we think global but act like local. It is important that we understand you from the get go.</p>
            </div>
          </Col>
        </Row>
      <Row className="d-flex">
        <Col md="6">
          <Benefit
            title="Software Development & Maintenance"
          />
          <Benefit
            title="Asset Management System"
          />
          <Benefit
            title="Human Resource Management System"
          />
          <Benefit
            title="Digital Signing Solution Integration"
          />
        </Col>
        <Col md="6">
          <Benefit
            title="Corporate Web Portal Development"
          />
          <Benefit
            title="IOT Solution Integration"
          />
          <Benefit
            title="ICT Infrastructure Design & Setup"
          />
          <Benefit
            title="FPX Payment Integration"
          />
        </Col>
      </Row>
      </Col>
      <Col md="6">
        <StyledImg
          fluid={data.file.childImageSharp.fluid}
          objectFit="contain"
          objectPosition="50% 50%"
        />
      </Col>
    </Row>
  </Container>
)

const BenefitsQuery = () => (
  <StaticQuery
    query={graphql`
      query BenefitsQuery {
        file(relativePath: { eq: "flat-office.png" }) {
          id
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `}
    render={(data) => <Benefits data={data} />}
  />
)

export default BenefitsQuery
